// @flow
import * as React from "react";
import styled from "styled-components";
import { rtl } from "./styled-mixins";
import "flag-icon-css/css/flag-icon.min.css";
import "currency-flags/dist/currency-flags.min.css";

import SilverImage from "../../images/currency/XAG2.svg";
import GoldImage from "../../images/currency/XAU2.svg";
import BchImage from "../../images/currency/BCH.svg";
import BtcImage from "../../images/currency/BTC.svg";
import EthImage from "../../images/currency/ETH.svg";
import LtcImage from "../../images/currency/LTC.svg";
import world_flag from "../../images/world_flag.svg";

export { SilverImage, GoldImage, BchImage, BtcImage, EthImage, LtcImage };

const View = styled.span`
  height: ${({ country }) =>
    country === "flag-icon-world" ? "24px !important" : "15px"};
  ${rtl("margin-right", "6px")};

  &.flag-icon-world {
    background-image: url(${world_flag});
    background-size: ${({ country }) =>
      country === "flag-icon-world" ? "cover" : "contain"};
  }

  &&& {
    width: 28px;
  }
`;

type Props = {
  className?: string,
  country: string
};

function Flag(props: Props) {
  let country = "";

  switch (props.country) {
    case "en":
      country = `flag-icon-gb`;
      break;
    case "hi":
      country = `flag-icon-in`;
      break;
    case "world":
      country = `flag-icon-world`;
      break;
    default:
      country = `flag-icon-${props.country}`;
      break;
  }

  return (
    <View
      className={`flag-icon ${country} ${props.className || ""}`}
      country={country}
    />
  );
}

export default Flag;

type CurrencyProps = {
  currency: string,
  className?: string,
  style?: { [key: string]: string | number }
};

export const CurrencyFlag = ({ currency, className, style }: CurrencyProps) => {
  const finalClassName = `currency-flag currency-flag-${currency} ${className ||
    ""}`;

  return <div className={finalClassName} style={style} />;
};



// WEBPACK FOOTER //
// ./src/components/common/Flag.js